import { useState } from 'react'
import { InfoModal } from './InfoModal'

const Alert = ({ alert, type }) => {
  const [isOpen, setIsOpen] = useState(false)
  const closeModal = () => setIsOpen(false)
  return (
    <>
      <article className=" dark:bg-[#372c25] text-orange-primary dark:text-orange-darkMode border-orange-primary dark:border-orange-darkMode px-2 py-2.5 text-xs bg-orange-100 border-l-8 rounded first-letter:uppercase flex justify-between">
        <span>{alert}</span>
        {type === 'validation' && (
          <button onClick={() => setIsOpen(!isOpen)} className="pr-2">
            <InfoIcon className="text-orange-primary hover:opacity-70 w-4" />
          </button>
        )}
      </article>
      {isOpen && <InfoModal isOpen={isOpen} closeModal={closeModal} />}
    </>
  )
}

export default Alert

const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 512 512"
    fill="currentColor"
    {...props}
  >
    <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208-93.3 208-208 208zm40-128h-16v-88c0-13.2-10.7-24-24-24h-32c-13.2 0-24 10.8-24 24s10.8 24 24 24h8v64h-16c-13.2 0-24 10.8-24 24s10.8 24 24 24h80c13.25 0 24-10.75 24-24s-10.7-24-24-24zm-40-144c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.3-32 32 14.3 32 32 32z" />
  </svg>
)
